var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card-body',{staticClass:"p-0"},[(_vm.contentData)?_c('ul',{staticClass:"content-item-list"},_vm._l((_vm.filteredContentData),function(item){return _c('ProductContentListItem',{key:item.id,class:[
				'content-item',
				{
					active: _vm.contentActive == item.id,
				},
			],attrs:{"item":item,"productVariantId":_vm.productVariantId,"purchased":_vm.purchased,"viewMode":_vm.viewMode,"parentContentId":_vm.parentContentId}})}),1):_vm._e(),(_vm.filteredContentData.length == 0)?_c('div',{staticClass:"no-data"},[_vm._v(" No content found ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }